export default __webpack_public_path__ + "static/media/1142.0350b31c.png";